var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.571 4.405H5.595V1.429h-1.19v2.976H1.429v1.19h2.976v2.976h1.19V5.595h2.976v-1.19z"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNTcxNDEgNC40MDQ3NUg1LjU5NTIyVjEuNDI4NTZINC40MDQ3NVY0LjQwNDc1SDEuNDI4NTZWNS41OTUyMkg0LjQwNDc1VjguNTcxNDFINS41OTUyMlY1LjU5NTIySDguNTcxNDFWNC40MDQ3NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };